import { render, staticRenderFns } from "./NotePlain.vue?vue&type=template&id=36244b57&scoped=true"
import script from "./NotePlain.vue?vue&type=script&lang=js"
export * from "./NotePlain.vue?vue&type=script&lang=js"
import style0 from "./NotePlain.vue?vue&type=style&index=0&id=36244b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36244b57",
  null
  
)

export default component.exports